import React, { useState, useMemo, useEffect } from "react";
import fieldPropTypes from "./field-prop-types";
import FieldBuilder from "./fields-builder";

const CollapsibleContainer = ({ field, appData, components, screen }) => {
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    if (field.data && field.data.hasOwnProperty("collapsed"))
      setCollapsed(field.data.collapsed);
  }, []);

  const detectWebLayout = layouts =>
    layouts.find(layout => layout["layout-id"] === "primary");
  const { containerFields } = detectWebLayout(field.fieldLayouts);

  const toggle = () => {
    setCollapsed(prev => !prev);
  };

  const triggerButtonTitle = useMemo(() => {
    if (collapsed) {
      return field.data && field.data.collapsedButtonTitle
        ? field.data.collapsedButtonTitle
        : "Show";
    }
    return field.data && field.data.expandedButtonTitle
      ? field.data.expandedButtonTitle
      : "Hide";
  }, [collapsed]);

  const nestedContent = containerFields.map(f => (
    <FieldBuilder
      key={`field_${f.name}`}
      field={f}
      appData={appData}
      components={components}
      screen={screen}
    />
  ));

  if (containerFields.length) {
    return (
      <div
        className={`collapsibleContainer ${field.name} ${
          field.params ? field.params.split("|").join(" ") : ""
        }`}
      >
        <button
          type='button'
          onClick={toggle}
          className={`triggerButton ${collapsed ? "" : "expanded"}`}
        >
          {triggerButtonTitle}
        </button>
        {!collapsed && <div className='mainContent'>{nestedContent}</div>}
      </div>
    );
  }

  return null;
};

CollapsibleContainer.propTypes = fieldPropTypes;

export default CollapsibleContainer;
